export class ValidatorDto{

    idValidator: number;
    firstName: string;
    lastName: string;
    telephone : string;
    constructor() {
    }
}